exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".search-results-header__container{display:flex;align-items:center;justify-content:space-between;color:#727e82}.search-results-header__section{display:flex;align-items:center}.search-results-header__view-switch{display:none}@media only screen and (min-width: 1024px){.search-results-header__view-switch{display:flex;align-items:center}}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};